var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('textarea',{staticClass:"fv-textarea fv-input",class:{'auto-height': _vm.autoHeight},style:({ height: _vm.height }),attrs:{"invalid":!_vm.fvValidate},domProps:{"value":_vm.value},on:{"focus":_vm.onFocus,"blur":_vm.onBlur,"input":_vm.onInput}})}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/framevuerk-builder/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/framevuerk-builder/node_modules/pug-html-loader/lib!./node_modules/framevuerk-builder/node_modules/vue-loader/lib??vue-loader-options!./src/components/fvTextarea.vue?vue&type=template&id=6bf3fefe&lang=pug&
// module id = 156
// module chunks = 0 1